'use client'

import { useTranslations } from 'next-intl'
import { useCallback, useEffect } from 'react'

import { AddressShippingSwitcherSlideIn } from '@maestro/commerce-blocks/components/address-shipping-switcher'
import { SHIPPING_ADDRESS_SWITCHER_MODAL_KEY } from '@maestro/commerce-blocks/components/address-shipping-switcher/address-shipping-switcher.constants'
import { useHash } from '@pearlconvert/ui/hooks/use-hash'
import { useModals } from '@pearlconvert/ui/providers/modals/modals.context'

export default function AddressShippingSwitcher() {
  const t = useTranslations('commerce-blocks.shipping-address-switcher')
  const { addModal } = useModals()
  const { removeHashParam } = useHash()

  const closeSwitcher = useCallback(() => {
    removeHashParam(SHIPPING_ADDRESS_SWITCHER_MODAL_KEY)
  }, [removeHashParam])

  useEffect(() => {
    addModal({
      key: SHIPPING_ADDRESS_SWITCHER_MODAL_KEY,
      hash: SHIPPING_ADDRESS_SWITCHER_MODAL_KEY,
      Component: <AddressShippingSwitcherSlideIn onClose={closeSwitcher} />,
      props: {
        title: t('title'),
        customClassName: 'shipping-address-switcher',
        hasBackButton: false,
      },
    })
  }, [addModal, closeSwitcher, t])

  return null
}
